import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white edit-course-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.user && _ctx.user.role_id == 4)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createLivNote && _ctx.createLivNote(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Agence : ", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    options: _ctx.drivers,
                    modelValue: _ctx.agencyLiv,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.agencyLiv) = $event)),
                    label: "name",
                    placeholder: "Choisir l'agence"
                  }, {
                    option: _withCtx(({ name, nb_colis }) => [
                      _createElementVNode("span", null, _toDisplayString(name) + " - " + _toDisplayString(nb_colis) + " Colis", 1)
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue"])
                ])
              ]),
              _cache[6] || (_cache[6] = _createElementVNode("hr", null, null, -1)),
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "submit"
                  }, "Ajouter")
                ])
              ], -1))
            ])
          ], 32))
        : _createCommentVNode("", true),
      (_ctx.user && _ctx.user.role_id == 3)
        ? (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createSentNote && _ctx.createSentNote(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Agence : ", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    options: _ctx.agenciesList,
                    modelValue: _ctx.agency,
                    "onUpdate:modelValue": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agency) = $event)),
                      _ctx.handleAgencySelection
                    ],
                    label: "name",
                    placeholder: "Select a zone"
                  }, {
                    option: _withCtx(({ name, nb_colis }) => [
                      _createElementVNode("span", null, _toDisplayString(name) + " - " + _toDisplayString(nb_colis) + " Colis", 1)
                    ]),
                    _: 1
                  }, 8, ["options", "modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Livreur : ", -1)),
                  _createVNode(_component_v_select, {
                    class: "custom-select-height",
                    options: _ctx.drivers,
                    modelValue: _ctx.driver,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.driver) = $event)),
                    label: "name"
                  }, null, 8, ["options", "modelValue"])
                ])
              ]),
              _cache[10] || (_cache[10] = _createElementVNode("hr", null, null, -1)),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-md-12" }, [
                _createElementVNode("div", { class: "form-group mb-15 mb-sm-20 mb-md-25" }, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    type: "submit"
                  }, "Ajouter")
                ])
              ], -1))
            ])
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}